import { ETextParamType_CurrentUserName, ETextParamType_ScriptCallComponentMethod, ETextParamType_SetMicTalkingState, worldViewerWindow } from './const';
import { getAudioList, getLocalStream, getMixerTab, getPeer, getSkyRoomId, getSkywayAvatarNumberForSend, getSkywayMicStateTimer, getSkywayName, getSkywayRoom, getSkywayStartToggle, getTextureCanvasList, getWorldId, setCurrentUserName, setMixerDistanceAt, setMixerFaderSettingAt, setMixerMuteAt, setMixerSettingAt, setSkywayAvatarNumber, setSkywayAvatarNumberForSend, setSkywayMicStateTimer, setSkywayName, setTextureCanvasList, setUploadedFileBuffer } from './logics/dataOps';
import { hel_video_SetVolume } from './logics/device';
import { defineNextTextCanvasIndex, getConfigUrlDOMElement, getLocalTextConfigUrlDOMElement, getLocalTextUserNameDOMElement, getMainCanvasDOMElement, getInputFileDOMElement, getUserNameDOMElement, getSkywayMsgDOMElement, getSkywayLocalTextDOMElement } from './logics/domOps';
import { requestMemoryAllocate, requestOnDropFiles, requestOnDropFilesBegin, requestOnDropFilesProgress, requestProcedureCallFor, requestReleaseMemoryFor, requestSetDataToHeap } from './logics/moduleCaller';
// Cookie
/**
 * heliodor, skyway, libからもC++からも参照されてる
 * @remarks
 * heliodor.js, heliodor_skyway, C++側とShare関数
 *
 * @param name
 * @param value
 */ worldViewerWindow.hel_set_cookie = (name, value)=>{
    const expires = ';Expires=Thu, 1-Jan-2030 00:00:00 GMT';
    // Cookie needs URL-encode.
    document.cookie = name + '=' + encodeURIComponent(value) + expires;
};
/**
 * heliodor, skyway, xr, libからもC++からも参照されてる
 * @remarks
 * heliodor.js, heliodor_skyway, C++側とShare関数
 *
 * @param name
 */ worldViewerWindow.hel_get_cookie = (name)=>{
    let matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : undefined;
};
//
/**
 * heliodor_skyway, xrからもC++からも参照されてる
 * @remarks
 * heliodor.js, heliodor_skyway, C++側とShare関数
 *
 * @param Type
 * @param Text
 */ worldViewerWindow.hel_setText = (Type, Text)=>{
    requestProcedureCallFor(Type, Text);
};
/**
 * @remarks
 * GUIのItemNameに依存した関数
 * itemName/componentName/methodName/param
 * @version 2.9.0
 * @param itemName
 * @param componentName
 * @param methodName
 * @param param
 */ worldViewerWindow.hel_script_CallComponentMethod = (itemName, componentName, methodName, param)=>{
    worldViewerWindow.hel_setText(ETextParamType_ScriptCallComponentMethod, itemName + ',' + componentName + ',' + methodName + ',' + param);
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param index
 */ worldViewerWindow.getPlayTimeAudio = (index)=>{
    var ref;
    const audioList = getAudioList();
    if (audioList[index] == null) {
        return 0;
    }
    return ((ref = audioList[index]) === null || ref === void 0 ? void 0 : ref.getPlayTimeAudio()) || 0;
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param type
 * @param volume
 * @param fadeVolume
 * @param distanceVolume
 * @param mute
 */ worldViewerWindow.hel_mixer_SetVolume = (type, volume, fadeVolume, distanceVolume, mute)=>{
    const realVolume = getMixerTab() * volume * fadeVolume * distanceVolume * (mute !== 0 ? 0.0 : 1.0);
    switch(type){
        case worldViewerWindow.HEL_AUDIO_TYPE_WORLD:
            worldViewerWindow.hel_set_cookie('mixervolume_world', volume);
            worldViewerWindow.hel_set_cookie('mixermute_world', mute);
            break;
        case worldViewerWindow.HEL_AUDIO_TYPE_VOICE:
            if (typeof worldViewerWindow.hel_skyway_SetMixerVolume == 'function') {
                worldViewerWindow.hel_skyway_SetMixerVolume(realVolume);
            }
            worldViewerWindow.hel_set_cookie('mixervolume_voice', volume);
            worldViewerWindow.hel_set_cookie('mixermute_voice', mute);
            break;
        case worldViewerWindow.HEL_AUDIO_TYPE_SE:
            worldViewerWindow.hel_set_cookie('mixervolume_se', volume);
            worldViewerWindow.hel_set_cookie('mixermute_se', mute);
            break;
        case worldViewerWindow.HEL_AUDIO_TYPE_SYSTEMSE:
            worldViewerWindow.hel_set_cookie('mixervolume_systemse', volume);
            worldViewerWindow.hel_set_cookie('mixermute_systemse', mute);
            break;
        case worldViewerWindow.HEL_AUDIO_TYPE_VIDEO:
            hel_video_SetVolume(realVolume);
            worldViewerWindow.hel_set_cookie('mixervolume_video', volume);
            worldViewerWindow.hel_set_cookie('mixermute_video', mute);
            break;
        default:
            return;
    }
    setMixerSettingAt(volume, type);
    setMixerFaderSettingAt(fadeVolume, type);
    setMixerDistanceAt(distanceVolume, type);
    setMixerMuteAt(mute, type);
};
// Texture
/**
 * heliodor.jsからもC++からも参照されてる
 * @param size
 */ worldViewerWindow.hel_texture_IsPower2Size = (size)=>{
    return (size & size - 1) == 0;
};
// Texture Canvas
/**
 * heliodor.jsからもC++からも参照されてる
 * @param width
 * @param height
 */ worldViewerWindow.createTextCanvas = (width, height)=>{
    const index = defineNextTextCanvasIndex();
    const textCanvas = document.createElement('canvas');
    setTextureCanvasList(textCanvas, index);
    textCanvas.style.visibility = 'hidden';
    textCanvas.width = width;
    textCanvas.height = height;
    return index;
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param index
 */ worldViewerWindow.getTextCanvas = (index)=>{
    const canvasList = getTextureCanvasList();
    if (index < 0 || index >= canvasList.length) {
        return null;
    }
    return getTextureCanvasList()[index];
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param index
 */ worldViewerWindow.getTextCanvasContext = (index)=>{
    const textCanvas = worldViewerWindow.getTextCanvas(index);
    if (textCanvas == null) return null;
    return textCanvas.getContext('2d');
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param index
 */ worldViewerWindow.clearTextCanvas = (index)=>{
    const textCanvas = worldViewerWindow.getTextCanvas(index);
    if (textCanvas == null) return;
    const context = textCanvas.getContext('2d');
    if (context == null) return;
    context.clearRect(0, 0, textCanvas.width, textCanvas.height);
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param index
 */ worldViewerWindow.releaseTextCanvasIndex = (index)=>{
    const canvasList = getTextureCanvasList();
    if (index < 0 || index >= canvasList.length || canvasList[index] === null) {
        return;
    }
    setTextureCanvasList(null, index);
};
// TAG
/**
 * heliodor.js, skywayからもC++からも参照されてる
 * @param name
 * @param params
 */ worldViewerWindow.hel_gtag = (name, params)=>{
    if (typeof worldViewerWindow.hel_analytics == 'function') {
        worldViewerWindow.hel_analytics('event', name, params);
    } else if (typeof worldViewerWindow.gtag == 'function') {
        worldViewerWindow.gtag('event', name, params);
    }
};
// File Drag & Drop
const setFileReaderEvents = (files)=>{
    if (files.length <= 0) {
        return;
    }
    const file = files[0];
    requestOnDropFilesBegin(file);
    //
    const reader = new FileReader();
    reader.onprogress = (evt)=>{
        if (!evt.lengthComputable || evt.total <= 0) {
            return;
        }
        requestOnDropFilesProgress(evt);
    };
    reader.onload = ()=>{
        setUploadedFileBuffer(reader.result);
        const ary_u8 = new Uint8Array(reader.result);
        //			console.log("onload " + file.name + " / " + ary_u8.length);
        const data = requestMemoryAllocate(ary_u8.length);
        requestSetDataToHeap(ary_u8, data);
        requestOnDropFiles(file, ary_u8, data);
        requestReleaseMemoryFor(data);
    };
    reader.readAsArrayBuffer(file);
};
/**
 * heliodor.jsからもC++からも参照されてる
 */ worldViewerWindow.hel_beginDropFiles = ()=>{
    const mainCanvas = getMainCanvasDOMElement();
    if (mainCanvas === undefined) {
        return;
    }
    mainCanvas.addEventListener('dragover', (e)=>{
        e.stopPropagation();
        e.preventDefault();
    }, false);
    mainCanvas.addEventListener('dragleave', (e)=>{
        e.stopPropagation();
        e.preventDefault();
    }, false);
    mainCanvas.addEventListener('drop', (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setFileReaderEvents(e.dataTransfer.files || []);
    }, false);
    const inputFile = getInputFileDOMElement();
    if (inputFile !== undefined) {
        inputFile.addEventListener('change', (e)=>{
            e.stopPropagation();
            e.preventDefault();
            // @ts-ignore
            const files = this.files;
            setFileReaderEvents(files || []);
        }, false);
    }
};
// configurl
/**
 * heliodor.jsからもC++からも参照されてる
 * @param show
 */ worldViewerWindow.hel_set_show_TextField_configurl = (show)=>{
    const localTextConfigUrl = getLocalTextConfigUrlDOMElement();
    if (localTextConfigUrl !== undefined) {
        localTextConfigUrl.style.visibility = show ? 'visible' : 'hidden';
    }
    const configUrl = getConfigUrlDOMElement();
    if (configUrl !== undefined) {
        configUrl.style.visibility = show ? 'visible' : 'hidden';
    }
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param x
 * @param y
 * @param width
 * @param height
 */ worldViewerWindow.hel_resize_configurl = (x, y, width, height)=>{
    const configUrl = getConfigUrlDOMElement();
    if (configUrl !== undefined) {
        configUrl.style.left = x + 'px';
        configUrl.style.top = y + 'px';
    }
    const localTextConfigUrl = getLocalTextConfigUrlDOMElement();
    if (localTextConfigUrl !== undefined) {
        localTextConfigUrl.style.width = width + 'px';
        localTextConfigUrl.style.height = height + 'px';
    }
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param text
 */ worldViewerWindow.hel_set_TextField_configurl = (text)=>{
    const localTextConfigUrl = getLocalTextConfigUrlDOMElement();
    if (localTextConfigUrl !== undefined) {
        localTextConfigUrl.value = text;
    }
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param text
 */ worldViewerWindow.hel_set_TextField_configurl_fontSize = (text)=>{
    const localTextConfigUrl = getLocalTextConfigUrlDOMElement();
    if (localTextConfigUrl !== undefined) {
        localTextConfigUrl.style.fontSize = text + 'px';
    }
};
// username
/**
 * heliodor.jsからもC++からも参照されてる
 * @param show
 */ worldViewerWindow.hel_set_show_TextField_UserName = (show)=>{
    const localTextUserName = getLocalTextUserNameDOMElement();
    if (localTextUserName !== undefined) {
        localTextUserName.style.visibility = show ? 'visible' : 'hidden';
    }
    const userName = getUserNameDOMElement();
    if (userName !== undefined) {
        userName.style.visibility = show ? 'visible' : 'hidden';
    }
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param name
 */ worldViewerWindow.hel_set_TextField_UserName = (name)=>{
    //console.log("*** A-END");
    const localTextUserName = getLocalTextUserNameDOMElement();
    //nameが 'undefined' ＝文字列で入ってる場合がある
    if (localTextUserName === undefined || name === undefined) {
        return;
    }
    localTextUserName.value = name;
//console.log("*** A-worldViewerWindow.g_localText_username(" + worldViewerWindow.g_localText_username + ")");
//console.log("*** A-worldViewerWindow.g_localText_username.value(" + worldViewerWindow.g_localText_username.value + ")");
//console.log("*** A-name(" + name + ")");
//console.log("*** A-END");
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param byCookie
 */ worldViewerWindow.hel_post_TextField_UserName = (byCookie)=>{
    let result_uname;
    if (Boolean(byCookie)) {
        const uname = worldViewerWindow.hel_get_cookie('playername');
        if (uname !== undefined) {
            if (uname.length > 0) {
                result_uname = uname;
            }
        }
    } else {
        const localTextUserName = getLocalTextUserNameDOMElement();
        if (localTextUserName !== undefined) {
            result_uname = localTextUserName.value;
        }
    }
    if (result_uname === undefined) {
        return;
    }
    //Send UserName to c++ side via SetText()
    setCurrentUserName(result_uname);
    worldViewerWindow.hel_setText(ETextParamType_CurrentUserName, result_uname);
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param text
 */ worldViewerWindow.hel_set_TextField_UserName_fontSize = (text)=>{
    const localTextUserName = getLocalTextUserNameDOMElement();
    if (localTextUserName !== undefined) {
        localTextUserName.style.fontSize = text + 'px';
    }
};
/**
 * heliodor.jsからもC++からも参照されてる
 */ worldViewerWindow.hel_update_TextField_UserName = ()=>{
    const localTextUserName = getLocalTextUserNameDOMElement();
    const peer = getPeer();
    const skywayName = getSkywayName();
    if (localTextUserName === undefined || peer === undefined) {
        return;
    }
    worldViewerWindow.hel_remove_emoji(localTextUserName);
    const value = localTextUserName.value;
    if (skywayName !== value) {
        setSkywayName(value);
        worldViewerWindow.hel_set_cookie('playername', value);
    }
    worldViewerWindow.hel_skyway_send_myinfo();
};
/**
 * heliodor.jsからもC++からも参照されてる
 * @param x
 * @param y
 * @param width
 * @param height
 */ worldViewerWindow.hel_resize_UserName = (x, y, width, height)=>{
    const userName = getUserNameDOMElement();
    if (userName !== undefined) {
        userName.style.left = x + 'px';
        userName.style.top = y + 'px';
    }
    const localTextUserName = getLocalTextUserNameDOMElement();
    if (localTextUserName !== undefined) {
        localTextUserName.style.width = width + 'px';
        localTextUserName.style.height = height + 'px';
    }
};
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @param show
 */ worldViewerWindow.hel_skyway_set_show_chatbox = (show)=>{
    const msg = getSkywayMsgDOMElement();
    if (msg !== undefined) {
        msg.style.visibility = show ? 'visible' : 'hidden';
    }
    const localText = getSkywayLocalTextDOMElement();
    if (localText === undefined) {
        return;
    }
    localText.style.visibility = show ? 'visible' : 'hidden';
};
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @param text
 */ worldViewerWindow.hel_skyway_set_TextField_localText_fontSize = (text)=>{
    const skywayLocalText = getSkywayLocalTextDOMElement();
    if (skywayLocalText === undefined) {
        return;
    }
    skywayLocalText.style.fontSize = text + 'px';
};
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @param x
 * @param y
 * @param width
 * @param height
 */ worldViewerWindow.hel_skyway_resize_chatbox = (x, y, width, height)=>{
    const msg = getSkywayMsgDOMElement();
    if (msg === undefined) {
        return;
    }
    msg.style.left = x + 'px';
    msg.style.top = y + 'px';
    const skywayLocalText = getSkywayLocalTextDOMElement();
    if (skywayLocalText === undefined) {
        return;
    }
    skywayLocalText.style.width = width + 'px';
    skywayLocalText.style.height = height + 'px';
};
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @remarks
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @param focus
 * @virtual
 */ worldViewerWindow.hel_skyway_send_chat_text = (focus = true)=>{
    const skywayLocalText = getSkywayLocalTextDOMElement();
    if (skywayLocalText === undefined || skywayLocalText.value == '') {
        return;
    }
    const value = skywayLocalText.value;
    worldViewerWindow.hel_remove_emoji(skywayLocalText);
    // Send message to all of the peers in the room via websocket
    const replace_text = worldViewerWindow.hel_skyway_to_code_colon(value);
    worldViewerWindow.hel_skyway_send_data('msg:' + replace_text);
    const peer = getPeer();
    const id = peer !== undefined ? peer.id : '';
    worldViewerWindow.hel_skyway_add_text_chat(id, replace_text);
    skywayLocalText.value = '';
    const mainCanvas = getMainCanvasDOMElement();
    if (focus && mainCanvas !== undefined) {
        mainCanvas.focus();
    }
    worldViewerWindow.hel_gtag('SendTextChat', {
        param0: getWorldId()
    });
};
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @remarks
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @virtual
 */ worldViewerWindow.hel_skyway_send_heartbeat = ()=>{
    const room = getSkywayRoom();
    if (room === undefined) {
        return;
    }
    const numOfPlayers = 1 + Object.values(room.getPeerConnections()).length;
    //	console.log("hel_skyway_send_heartbeat " + NumofPlayer);
    worldViewerWindow.sendHeartbeat(getSkyRoomId(), numOfPlayers);
};
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @remarks
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @param peerId
 * @param volume
 * @virtual
 */ worldViewerWindow.hel_skyway_SetVoiceAttenuate = (peerId, volume)=>{
    const Player = worldViewerWindow.hel_skyway_get_player(peerId);
    if (Player == null) return;
    Player.SetVoiceAttenuate(volume);
};
/**
 * heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @remarks
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @virtual
 */ worldViewerWindow.hel_skyway_send_myinfo = ()=>{
    worldViewerWindow.hel_skyway_send_data('join:' + getSkywayName() + ':' + getSkywayAvatarNumberForSend() + ':' + (getSkywayStartToggle() ? 1 : 0));
    worldViewerWindow.hel_skyway_send_data('avatar:' + getSkywayAvatarNumberForSend());
};
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @remarks
 *
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 *
 * @param param
 * @virtual
 */ worldViewerWindow.hel_skyway_send_data = (param)=>{
    const room = getSkywayRoom();
    if (room === undefined) {
        return;
    }
    room.send(param);
};
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @param avatar
 */ worldViewerWindow.hel_skyway_set_avatar_forsend = (avatar)=>setSkywayAvatarNumberForSend(avatar)
;
// Avatar
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * @param avatar
 */ worldViewerWindow.hel_skyway_change_avatar = (avatar)=>{
    setSkywayAvatarNumber(avatar);
    setSkywayAvatarNumberForSend(avatar);
    worldViewerWindow.hel_gtag('AvatarChange', {
        param0: getWorldId(),
        param1: avatar
    });
    worldViewerWindow.hel_set_cookie('Avatar', avatar);
};
const hel_skyway_detect_voice = (input, analyzer, timeDomainArray, frequencyArray)=>{
    analyzer.getFloatTimeDomainData(timeDomainArray);
    analyzer.getFloatFrequencyData(frequencyArray);
    // @ts-ignore
    const maxDomain = Math.max(...timeDomainArray);
    //  console.log('voice!', timeDomainArray, frequencyArray);
    //  console.log('voice!', analyzer.minDecibels, analyzer.maxDecibels);
    //    console.log('voice!', maxDomain);
    const voice_threshold = 0.05;
    if (maxDomain > voice_threshold) {
        worldViewerWindow.hel_canvas_SetLayoutShow('HUD_Voice', true);
        worldViewerWindow.hel_setText(ETextParamType_SetMicTalkingState, '1');
        worldViewerWindow.hel_canvas_SetGUIShow('hud_voicechat_on', false);
    } else {
        worldViewerWindow.hel_canvas_SetLayoutShow('HUD_Voice', false);
        worldViewerWindow.hel_setText(ETextParamType_SetMicTalkingState, '0');
        worldViewerWindow.hel_canvas_SetGUIShow('hud_voicechat_on', true);
    }
};
/**
 * heliodor.js, heliodor_skyway_rcp.js, heliodor_skyway_xrw.js, C++から参照あり
 * TODO
 * agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @param state
 * @virtual
 */ worldViewerWindow.hel_skyway_set_mic_state = (state)=>{
    const localStream = getLocalStream();
    if (localStream === undefined) {
        return;
    }
    const tracks = localStream.getAudioTracks();
    if (tracks.length <= 0) {
        return;
    }
    tracks[0].enabled = state;
    if (state) {
        const audioCtx = new AudioContext();
        const input = audioCtx.createMediaStreamSource(localStream);
        const analyzer = audioCtx.createAnalyser();
        input.connect(analyzer);
        const timeDomainArray = new Float32Array(analyzer.fftSize);
        const frequencyArray = new Float32Array(analyzer.frequencyBinCount);
        const timer = setInterval(hel_skyway_detect_voice.bind(null, input, analyzer, timeDomainArray, frequencyArray), 200);
        setSkywayMicStateTimer(timer);
    } else {
        worldViewerWindow.hel_canvas_SetLayoutShow('HUD_Voice', false);
        worldViewerWindow.hel_setText(ETextParamType_SetMicTalkingState, '0');
        const timer = getSkywayMicStateTimer();
        if (timer !== undefined) {
            clearInterval(timer);
        }
    }
};
